import type { AuthorInfo } from "@serophin/nottldr-shared";
import { Loader2, UserCheck } from "lucide-preact";
import { ExploreButtons } from "../explore/ExploreButtons";
import { AuthorCard } from "./AuthorCard";

const Loading = () => (
  <div class="flex justify-center items-center py-12">
    <Loader2 size={36} class="animate-spin mr-2 text-gray-500" />
    <div class="text-lg text-gray-500">Loading followed authors...</div>
  </div>
);

const NoneFollowed = () => (
  <div class="bg-white dark:bg-neutral-800 rounded-2xl shadow-lg p-6 text-center">
    <div class="flex justify-center mb-3">
      <div class="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-full">
        <UserCheck class="text-blue-600 dark:text-blue-400" size={32} />
      </div>
    </div>
    <h2 class="text-xl font-bold text-gray-900 dark:text-white mb-2">No Authors Followed</h2>
    <p class="text-sm text-gray-600 dark:text-gray-300 mb-4">Explore our authors and follow the ones you're interested in!</p>
    <ExploreButtons />
  </div>
);

/** The authors the visitor follows; `undefined` while they load. */
export const AuthorsFollowed = ({ authors }: { authors: AuthorInfo[] | undefined }) => {
  if (!authors) {
    return <Loading />;
  }
  if (authors.length === 0) {
    return <NoneFollowed />;
  }
  return (
    <div>
      {authors.map((author) => (
        <div key={author.alias} class="mb-6">
          <AuthorCard author={author} />
        </div>
      ))}
    </div>
  );
};
